import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import jwt_decode from 'jwt-decode';
import adminAuthApi from '../api/adminAuthApi';
import adminSchemaApi from '../api/adminSchemaApi';
import AdminHeader from './AdminHeader';
import '../styles/admin-theme.css';

function adminTokenIsValid(raw) {
  if (raw == null || typeof raw !== 'string' || !raw.trim()) {
    return false;
  }
  try {
    const { exp } = jwt_decode(raw.trim());
    return Boolean(exp && exp * 1000 > Date.now());
  } catch {
    return false;
  }
}

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [schemas, setSchemas] = useState([]);
  const [authReady, setAuthReady] = useState(false);
  const menuTabs = [
    { id: 'home', label: 'Home', url: '/admin' },
    { id: 'schemas', label: 'Schemas', url: '/admin/schemas' },
    { id: 'pricebooks', label: 'Pricebooks', url: '/admin/pricebooks' },
    { id: 'license-types', label: 'License Types', url: '/admin/license-types' },
    { id: 'plans', label: 'Plans', url: '/admin/plans' },
  ];
  const [selectedSchema, setSelectedSchema] = useState(
    localStorage.getItem('adminSchema') || ''
  );

  useLayoutEffect(() => {
    const raw =
      typeof window !== 'undefined' ? localStorage.getItem('adminToken') : null;
    if (!adminTokenIsValid(raw)) {
      adminAuthApi.logout();
      window.location.replace('/admin/login');
      return;
    }
    setAuthReady(true);
  }, []);

  useEffect(() => {
    const onStorage = event => {
      if (event.key !== 'adminToken') return;
      const next = event.newValue;
      if (!adminTokenIsValid(next)) {
        adminAuthApi.logout();
        navigate('/admin/login', { replace: true });
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [navigate]);

  useEffect(() => {
    if (!authReady) {
      return undefined;
    }
    const loadSchemas = async () => {
      try {
        const companies = await adminSchemaApi.fetchSchemas();
        const normalized = companies
          .filter(company => company?.tenantcode)
          .map(company => ({
            value: company.tenantcode,
            label: company.name
              ? `${company.name} (${company.tenantcode})`
              : company.tenantcode,
          }));
        setSchemas(normalized);
      } catch (error) {
        console.error('Admin schema list error:', error);
        setSchemas([]);
      }
    };

    loadSchemas();
  }, [authReady]);

  const handleLogout = () => {
    adminAuthApi.logout();
    setAuthReady(false);
    navigate('/admin/login');
  };

  const handleSchemaChange = value => {
    setSelectedSchema(value);
    localStorage.setItem('adminSchema', value);
  };

  if (!authReady) {
    return (
      <div
        className='admin-theme d-flex align-items-center justify-content-center'
        style={{ minHeight: '50vh' }}
      >
        <span className='text-muted'>Redirecting to login…</span>
      </div>
    );
  }

  return (
    <div className='admin-dashboard'>
      <AdminHeader
        schemas={schemas}
        selectedSchema={selectedSchema}
        onSchemaChange={handleSchemaChange}
        onLogout={handleLogout}
        menuTabs={menuTabs}
      />
      <Container className='p-4'>
        <Outlet />
      </Container>
    </div>
  );
};

export default AdminDashboard;
